import React from 'react'
import Topheader from '../Components/Topheader'
import Homeslider from '../Components/Homeslider'
import Popupform from '../Components/PopupScroll/PopupScroll/Popupform'



const Home = () => {
  return (
   <>
   {/* <Navi /> */}
   {/* <Topheader/> */}
   <Homeslider />

  
   
   </>
  )
}

export default Home
